export default class FaqEntry {

    static copy (other) {
        if (!(other instanceof FaqEntry)) {
            throw new Error('cannot copy non-FaqEntry into FaqEntry')
        }

        var f = new FaqEntry()
        f.id = other.id
        f.creatorUuid = other.creatorUuid
        f.creatorEmail = other.creatorEmail
        f.title = other.title
        f.slug = other.slug
        f.text = other.text
        f.keywords = other.keywords
        f.created = other.created
        f.modified = other.modified

        return f
    }

    /**
     * Construct a FaqEntry using values from another object.
     * @param data The object to take values from.
     * @throws if a field is missing or invalid.
     */
    static fromObject (data) {
        if (typeof data !== 'object') {
            throw new Error('cannot load faq entry data from non-object')
        }

        var f = new FaqEntry()

        var problems = []
        if (typeof data.id !== 'number') {
            problems.push('id')
        } else {
            f.id = data.id
        }

        if (typeof data.creatoruuid !== 'string') {
            problems.push('creator_uuid')
        } else {
            f.creatorUuid = data.creatoruuid
        }

        if (typeof data.title !== 'string') {
            problems.push('title')
        } else {
            f.title = data.title
        }

        if (typeof data.created !== 'string') {
            problems.push('created')
        } else {
            f.created = data.created
        }

        if (typeof data.slug !== 'string') {
            problems.push('slug')
        } else {
            f.slug = data.slug
        }

        if (typeof data.keywords !== 'string') {
            problems.push('keywords')
        } else {
            f.keywords = data.keywords.split(',').map(k => k.trim())
        }

        if (typeof data.text !== 'string') {
            problems.push('text')
        } else {
            f.text = data.text
        }

        if (problems.length > 0) {
            throw new Error(`missing or invalid values while parsing FAQ entry: ${JSON.stringify(problems)}`)
        }

        // Add optional fields
        f.creatorEmail = typeof data.creatoremail === 'string' && data.creatoremail !== ''
            ? data.creatoremail
            : 'N/A'
        
        f.modified = typeof data.modified === 'string' && data.modified !== ''
            ? data.modified
            : ''
        
        return f
    }

    constructor () {
        this.id = 0
        this.creatorUuid = ''
        this.creatorEmail = ''
        this.title = ''
        this.slug = ''
        this.text = ''
        this.keywords = []
        this.created = ''
        this.modified = ''
    }
}
